import React, { useEffect } from "react"
import { Link, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import Layout from "../components/layout"
import SEO from "../components/seo"
// import { motion } from "framer-motion"
// import FadeBox from "../components/atoms/fade"
// import StaggerWrap from "../components/atoms/stagger-wrap"
// import StaggerBox from "../components/atoms/stagger"
// import IntersectionObserver from "../components/atoms/intersection-observer"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import SwiperCore, { Navigation, Pagination, Lazy } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import { css } from "@emotion/react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { device } from "../components/device"

import "swiper/swiper.scss"

SwiperCore.use([Navigation, Pagination, Lazy])

const ProjectPostTemplate = ({ data: { previous, next, post } }) => {
  // const spacing = "3em clamp(1.2rem, 4vw, 6rem)"
  const spacingH = "clamp(1.2rem, 4vw, 6rem)"
  const projectImage = post.singleProject.projectImages
  // useEffect(() => {
  //   function colorHeader() {
  //     const white = document.querySelector(".white")
  //     const app = document.querySelector(".app")
  //     if (white !== null && white.classList.contains("white")) {
  //       app.classList.add("white")
  //     } else {
  //       app.classList.remove("white")
  //     }
  //   }
  //   colorHeader()
  // })

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)
    const intros = gsap.utils.toArray(".fade-intro")
    intros.forEach((intro, i) => {
      const anim = gsap.fromTo(
        intro,
        { autoAlpha: 0, y: 50 },
        { duration: 1, autoAlpha: 1, y: 0, stagger: 0.75, ease: "power1.inOut" }
      )
      ScrollTrigger.create({
        trigger: intro,
        animation: anim,
        toggleActions: "play none none none",
      })
    })

    // const fades = gsap.utils.toArray(".fade")
    // fades.forEach((fade, i) => {
    //   const anim = gsap.fromTo(
    //     fade,
    //     { autoAlpha: 0, y: 50 },
    //     { duration: 1.5, autoAlpha: 1, y: 0 }
    //   )
    //   ScrollTrigger.create({
    //     trigger: fade,
    //     animation: anim,
    //     scrub: true,
    //     start: "top 75%",
    //     end: "+=300px",
    //     toggleActions: "play none play none",
    //     // stagger: 0.2,
    //   })
    // })
  }, [])

  return (
    <Layout>
      <SEO title={post.title} description={post.content} />

      <article
        className="project-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12rem ${spacingH} 4.5rem;
            @media ${device.laptopS} {
              padding: 12rem ${spacingH} 6rem;
            }
          `}
          key="1"
        >
          {/* <div
            css={css`
              display: none;
              @media ${device.laptop} {
                width: 50%;
                display: block;
              }
            `}
          >
            <GatsbyImage
              image={
                post.featuredImage.node.localFile.childImageSharp
                  .gatsbyImageData
              }
              alt={post.featuredImage.node.altText}
              className="project-hero-image fade"
            />
          </div> */}
          <div
            css={css`
              width: 100%;
              align-self: center;

              // @media ${device.laptop} {
              //   width: 50%;
              // }
            `}
            className="fade-intro"
          >
            <div
              css={css`
                padding: 0;
                max-width: 33.33rem;

                // @media ${device.laptop} {
                //   padding: 0 ${spacingH};
                //   margin: 0 auto;
                }
              `}
            >
              <h1
                css={css`
                  font-size: clamp(1.15rem, 2.45621vw, 1.225rem);
                `}
                itemProp="headline"
              >
                {parse(post.title)}
              </h1>

              {!!post.content && (
                <div
                  itemProp="articleBody"
                  css={css`
                    font-size: clamp(1.15rem, 2.45621vw, 1.225rem);
                  `}
                  // dangerouslySetInnerHTML={{
                  //   __html: post.content,
                  // }}
                >
                  {parse(post.content)}
                </div>
              )}
            </div>
          </div>
        </header>

        <section className="project-carousel fade-intro">
          <div
            css={css`
              display: flex;
              z-index: 9;
              align-items: center;
              justify-content: center;
              padding-bottom: 1.5em;
              visibility:hidden: opacity: 0
            `}
          >
            <div
              css={css`
                padding: 0 ${spacingH};
                font-size: 1.25rem;
              `}
              className="swiper-prev"
            >
              ←
            </div>
            <div
              className="swiper-project-pagination"
              css={css`
                padding: 0 ${spacingH};
                min-width: 200px;
                text-align: center;
                visibility:hidden: opacity: 0
              `}
            ></div>
            <div
              css={css`
                padding: 0 ${spacingH};
                font-size: 1.25rem;
              `}
              className="swiper-next"
            >
              →
            </div>
          </div>
          <div css={css`visibility:hidden: opacity: 0`}>
            <Swiper
              className="project-slider"
              slidesPerView={`auto`}
              centeredSlides={true}
              speed={1000}
              loop={true}
              grabCursor={true}
              breakpoints={{
                768: {
                  slidesPerView: 1.35,
                },
                1280: {
                  slidesPerView: 1.5,
                },
                1680: {
                  slidesPerView: 1.6,
                },
              }}
              navigation={{
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
                clickable: true,
                renderNextButton: className => {
                  return '<span class"' + className + '"></span>'
                },
                renderPrevButton: className => {
                  return '<span class"' + className + '"></span>'
                },
              }}
              pagination={{
                el: ".swiper-project-pagination",
                type: "custom",
                renderCustom: (swiper, current, total) => {
                  return current + " of " + total
                },
                clickable: true,
              }}
              onSwiper={swiper => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {projectImage.map(image => (
                <SwiperSlide key={image.projectImage.id}>
                  <GatsbyImage
                    image={
                      image.projectImage.localFile.childImageSharp
                        .gatsbyImageData
                    }
                    alt={image.projectImage.altText}
                    objectFit="contain"
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </article>

      <nav
        css={css`
          padding: 4.5rem ${spacingH} 6rem;
          display: grid;
          grid-template-columns: 2fr 1fr 2fr;
          @media ${device.laptopS} {
            padding: 6rem ${spacingH} 9rem;
          }
        `}
        className="blog-post-nav fade"
      >
        <div
          css={css`
            text-align: left;
            padding: 0 ${spacingH} 0 0;
          `}
        >
          {previous && (
            <Link to={previous.uri} rel="prev">
              ←{" "}
              <span
                css={css`
                  display: none;
                  @media ${device.laptopS} {
                    display: inline-block;
                  }
                `}
              >
                {parse(previous.title)}
              </span>
            </Link>
          )}
        </div>
        <div
          css={css`
            text-align: center;
          `}
        >
          <AnchorLink to="/#projects" stripHash>
            Projects
          </AnchorLink>
        </div>
        <div
          css={css`
            text-align: right;
            padding: 0 0 0 ${spacingH};
          `}
        >
          {next && (
            <Link to={next.uri} rel="next">
              <span
                css={css`
                  display: none;
                  @media ${device.laptopS} {
                    display: inline-block;
                  }
                `}
              >
                {parse(next.title)}
              </span>{" "}
              →
            </Link>
          )}
        </div>
        {/* </ul> */}
      </nav>
    </Layout>
  )
}

export default ProjectPostTemplate

export const pageQuery = graphql`
  query ProjectPostById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    post: wpProject(id: { eq: $id }) {
      id
      content
      title
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          altText
          description
          caption
          imageCSS {
            css
          }
          localFile {
            childImageSharp {
              gatsbyImageData(quality: 80, placeholder: DOMINANT_COLOR)
            }
          }
        }
      }
      singleProject {
        projectImages {
          projectImage {
            sourceUrl
            id
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 80, placeholder: DOMINANT_COLOR)
              }
            }
          }
        }
      }
    }
    previous: wpProject(id: { eq: $previousPostId }) {
      uri
      title
    }
    next: wpProject(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`
